//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'echarts-liquidfill/src/liquidFill.js'; // 引入提示框

require('echarts/lib/component/tooltip'); // 引入标题组件


require('echarts/lib/component/title');

require('echarts/lib/component/legendScroll');

import { getAction } from '@/api/manage'; // 日期格式化插件

import moment from 'moment';
import { queryRealtime as _queryRealtime, queryWarn, querySiteList as _querySiteList } from '@/api/api'; // 水文监测

import hydrology from '@comp/bigData/hydrology'; // 水文统计

import waterWenStatistics from '@comp/bigData/waterWenStatistics-chukou';
import screenfull from 'screenfull';
var scrollTimer;
var dateTimer;
var timer;
export default {
  data: function data() {
    return {
      headDate: '',
      headWeek: '',
      headTime: '',
      waterWarnList: [],
      isFullscreen: false,
      dataMap: {},
      remark: '',
      imgSrc: ''
    };
  },
  mounted: function mounted() {
    moment.locale('zh-cn');
  },
  components: {
    hydrology: hydrology,
    waterWenStatistics: waterWenStatistics
  },
  methods: {
    initData: function initData() {
      var _this = this;

      this.queryRealtime();
      this.querySiteList();
      this.getWarn();
      scrollTimer = setInterval(this.scroll, 1000);
      dateTimer = setInterval(function () {
        var date = new Date();
        _this.headDate = moment(date).format('YYYY年MM月DD日');
        _this.headWeek = moment(date).format('dddd');
      }, 60000);
      this.getDate();
    },
    clearTimer: function clearTimer() {
      clearInterval(scrollTimer);
      clearInterval(dateTimer);
      clearInterval(timer);
    },
    toData: function toData() {
      this.$router.push('/ds/index');
    },
    querySiteList: function querySiteList() {
      var _this2 = this;

      var that = this; // 污水站点

      _querySiteList({
        id: '7'
      }).then(function (res) {
        if (res) {
          _this2.remark = res.result.records[0].remark;
          _this2.imgSrc = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          console.log(location.origin);
        }
      });
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    getDate: function getDate() {
      var _this3 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headWeek = moment(date).format('dddd');
      this.headTime = moment(date).format('HH:mm:ss');
      timer = setInterval(function () {
        var time = new Date();
        _this3.headTime = moment(time).format('HH:mm:ss');

        _this3.$forceUpdate();
      }, 1000);
    },
    scroll: function scroll() {
      var _this4 = this;

      setTimeout(function () {
        if (_this4.waterWarnList.length > 5) {
          _this4.waterWarnList.push(_this4.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this4.waterWarnList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    // 获取表数据
    queryRealtime: function queryRealtime() {
      var _this5 = this;

      var that = this;
      var params = {
        type: 1,
        id: 7
      }; // 污水站点

      _queryRealtime(params).then(function (res) {
        if (res) {
          _this5.dataMap = res.result.records[0].dataMap;
        }
      });
    },
    getWarn: function getWarn() {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10,
        scopeId: '7',
        scope: 1,
        st: 53
      }; // 污水站点

      queryWarn(params).then(function (res) {
        if (res) {
          that.waterWarnList = res.result.records;
        }
      });
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    }
  }
};